import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=19e2b513&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=ts&"
export * from "./Score.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e2b513",
  null
  
)

export default component.exports